// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { isBotUA } from '@/utils/bot-detection';

const isProduction = process.env.NEXT_PUBLIC_ENV === 'production';

function getSampleRate(defaultValue = 0) {
  const sentryClient: Record<string, unknown> = window.__ZL_SENTRY_FLAG;
  if (sentryClient) {
    const sampleRate = +sentryClient.sampleRate;
    if (sampleRate >= 0 && sampleRate <= 1) {
      return sampleRate;
    }
  }
  return defaultValue;
}

function isBrowserSpider() {
  return typeof navigator !== 'undefined' && isBotUA(navigator.userAgent);
}

export function startClientSentry() {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_ENV,

    maxBreadcrumbs: 50,
    tracesSampleRate: 0,
    profilesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,

    debug: false,
    enabled: isProduction,
    sampleRate: 1,
    beforeSend: (event, hint) => {
      if (isBrowserSpider()) return null;
      if (
        event.tags?.monitoring_priority === 'api_failure' ||
        event.tags?.monitoring_priority === 'frontend_500'
      ) {
        return event;
      }

      const sampleRate = getSampleRate();

      if (sampleRate > 0 && sampleRate <= 1) {
        return Math.random() < sampleRate ? event : null;
      }

      return null;
    },

    // 禁止浏览器未捕获异常、未处理 Promise rejection、XHR/事件回调异常自动上报。
    integrations: (defaultIntegrations) =>
      defaultIntegrations.filter((i) => !['GlobalHandlers', 'BrowserApiErrors'].includes(i.name)),
  });
}
